<template>
  <div class="select-input">
    <select v-model="selectedFilter" v-on:change="filterRsvp">
      <option value="-1" selected>{{ $t('dispatch.filterPlaceholder') }}</option>
      <option v-for="(filter, index) in filters" :value="index">
        {{ filter.name }}
      </option>
      <option v-if="addCustom" value="custom">Custom</option>
    </select>
    <i class="fas fa-caret-down"></i>
  </div>
</template>

<script>
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
import ApiDispatchDriver from '@/modules/api/dispatch/drivers'
import ApiRoutingReservation from '@/modules/api/routing/reservations'
export default {
  name: 'reservation-filter',
  props: [ 'forRouting', 'addCustom' ],
  computed: {
    filters () { return this.$store.state.reservation.reservationFilters },
    selectedFilter: {
      get () { return this.$store.state.reservation.selectedFilter },
      set (value) {
        let selected = value
        if (value !== 'custom') { selected = parseInt(value) }
        this.$store.commit('reservation/setSelectedFilter', selected)
      }
    }
  },
  methods: {
    filterRsvp () {
      let self = this
      if (self.forRouting) {
        console.log('For Routing')
        ApiRoutingReservation.getReservations(self, {})
        return
      }

      // save filter
      if (self.selectedFilter !== -1 && self.selectedFilter !== 'custom') {
        self.$plugins.storage.set('ADMIN_DISPATCH_FILTER', self.filters[self.selectedFilter].id)
      } else {
        self.$plugins.storage.remove('ADMIN_DISPATCH_FILTER')
      }
      self.$store.commit('dispatch/resetRsvpPaging')
      ApiDispatchReservation.getReservations(self)
      ApiDispatchDriver.getStagingDrivers(self)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-input{
  position: relative;

  & i{
    position: absolute;
    top: 15px;
    right: 15px;
    color: #aaa;
  }
}
select{
  height: 50px;
  line-height: 50px;
  border-radius: 0;
  outline: 0;
  appearance: none;
  border: 0;
  background-color: #fff;
  padding: 0 20px 0 15px;
  border-right: 1px solid rgba(0,0,0,0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ReservationFilter.vue